const userAgent = global.navigator.userAgent;

const isWindowsPhone = userAgent.indexOf('IEMobile') !== -1;
const isIPhone = userAgent.indexOf('iPhone') !== -1 && !isWindowsPhone;
const isIPad = userAgent.indexOf('iPad') !== -1 && !isWindowsPhone;
export const isIOS = isIPhone || isIPad;
export const isAndroid = !!~userAgent.indexOf('Android');
export const isEmbedded = userAgent.indexOf('embedded') !== -1 || (isAndroid && !!~userAgent.indexOf('wv'));
